export default __webpack_public_path__ + "static/media/celebration.7678411f.gif";